import { render, staticRenderFns } from "./ReclamoDetailForm.html?vue&type=template&id=51c4a6fa&external"
import script from "./ReclamoDetailForm.vue?vue&type=script&lang=js"
export * from "./ReclamoDetailForm.vue?vue&type=script&lang=js"
import style0 from "./ReclamoDetailForm.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports